{
  "$schema": "https://mux.run/theme.json",
  "name": "Carbonfox",
  "id": "carbonfox",
  "light": {
    "palette": {
      "neutral": "#8e8e8e",
      "ink": "#161616",
      "primary": "#0072c3",
      "accent": "#da1e28",
      "success": "#198038",
      "warning": "#f1c21b",
      "error": "#da1e28",
      "info": "#0043ce",
      "interactive": "#0f62fe",
      "diffAdd": "#198038",
      "diffDelete": "#da1e28"
    },
    "overrides": {
      "syntax-comment": "#6f6f6f",
      "syntax-keyword": "#8a3ffc",
      "syntax-string": "#198038",
      "syntax-primitive": "#0f62fe",
      "syntax-property": "#0043ce",
      "syntax-type": "#8a5f00",
      "syntax-constant": "#da1e28"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#393939",
      "ink": "#f2f4f8",
      "primary": "#33b1ff",
      "accent": "#ff8389",
      "success": "#42be65",
      "warning": "#f1c21b",
      "error": "#ff8389",
      "info": "#78a9ff",
      "interactive": "#4589ff",
      "diffAdd": "#42be65",
      "diffDelete": "#ff8389"
    },
    "overrides": {
      "syntax-comment": "#6f6f6f",
      "syntax-keyword": "#be95ff",
      "syntax-string": "#42be65",
      "syntax-primitive": "#33b1ff",
      "syntax-property": "#78a9ff",
      "syntax-type": "#f1c21b",
      "syntax-constant": "#ff8389"
    }
  }
}
